import { BrandLinkElementType } from "app/common/constants/structuredText"
import { RouteMgr } from "app/common/routes"
import { BrandVM } from "app/models"
import { Link } from "blitz"
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from "react"

type BrandLinkElementProps = PropsWithChildren<{
  attributes: DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
  brand: BrandVM
  element: BrandLinkElementType
}>

export const BrandLinkElement = ({ attributes, brand }: BrandLinkElementProps) => {
  return (
    <Link
      href={RouteMgr.BrandPage({
        slug: brand.slug,
      })}
    >
      <a {...attributes}>{brand.name}</a>
    </Link>
  )
}
